export function createInvalidTokenErrorMessage(message: string) {
    const errorContainer = document.createElement('div')
    const iconContainer = document.createElement('div')
    const errorMessage = document.createElement('span')
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')

    errorContainer.className = 'invalid-token-error'
    errorContainer.style.display = 'flex'
    errorContainer.style.justifyContent = 'center'
    errorContainer.style.padding = '8px 12px'
    errorContainer.style.backgroundColor = '#ffeceb'
    errorContainer.style.border = '#ffd0cd 1px solid'
    errorContainer.style.borderRadius = '8px'
    errorContainer.style.cursor = 'default'

    iconContainer.style.marginRight = '8px'

    svg.setAttribute('width', '16')
    svg.setAttribute('height', '16')
    svg.setAttribute('viewBox', '0 0 24 24')
    svg.setAttribute('fill', '#FF6259')

    path.setAttribute(
        'd',
        'M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM13 17h-2v-2h2v2zm0-4h-2V7h2v6'
    )

    errorMessage.innerText = message
    errorMessage.className = 'error-message'

    svg.appendChild(path)
    iconContainer.appendChild(svg)
    errorContainer.appendChild(iconContainer)
    errorContainer.appendChild(errorMessage)
    document.body.appendChild(errorContainer)
}
